import { Dayjs } from "dayjs";
import { ChartPaginationDirection } from "src/api/generated/common/chartPaginationDirection.ts";

interface ResolveControlledRefreshParams {
	requestedRecordsBeforeLimit: Dayjs | null | undefined;
	requestedPaginationDirection: ChartPaginationDirection | undefined;
	controlledRecordsBeforeLimit: Dayjs | null | undefined;
}

export function resolveControlledRefresh({
	requestedRecordsBeforeLimit,
	requestedPaginationDirection,
	controlledRecordsBeforeLimit,
}: ResolveControlledRefreshParams) {
	if (controlledRecordsBeforeLimit === undefined) {
		return {
			recordsBeforeLimit: requestedRecordsBeforeLimit,
			paginationDirection: requestedPaginationDirection,
		};
	}

	const recordsBeforeLimit =
		requestedRecordsBeforeLimit === undefined ? controlledRecordsBeforeLimit : requestedRecordsBeforeLimit;
	return {
		recordsBeforeLimit,
		paginationDirection:
			requestedPaginationDirection ?? (recordsBeforeLimit == null ? "LAST_PAGE" : "CURRENT_PAGE"),
	};
}

interface ResolveRecordsBeforeLimitParams {
	refreshLimit: Dayjs | null | undefined;
	initialLimit: Dayjs | null | undefined;
	hasLoadedData: boolean;
}

export function resolveRecordsBeforeLimit({
	refreshLimit,
	initialLimit,
	hasLoadedData,
}: ResolveRecordsBeforeLimitParams): string | undefined {
	if (refreshLimit !== undefined) {
		return refreshLimit?.toISOString();
	}

	return hasLoadedData ? undefined : initialLimit?.toISOString();
}
